// extracted by mini-css-extract-plugin
export var avatarContainer = "_q-0";
export var avatarTypingWave = "_q-i";
export var gray = "_q-f";
export var green = "_q-c";
export var icon = "_q-9";
export var image = "_q-1";
export var lg = "_q-6";
export var md = "_q-5";
export var presenceDot = "_q-b";
export var red = "_q-d";
export var sm = "_q-4";
export var status = "_q-a";
export var typingDot = "_q-h";
export var typingPill = "_q-g";
export var xl = "_q-7";
export var xs = "_q-3";
export var xxl = "_q-8";
export var xxs = "_q-2";
export var yellow = "_q-e";